import { Icon, type IconProps } from '../icon'

type IconDualColorBottomProps = Omit<IconProps, 'size'>

export function IconDualColorBottom({
  children,
  color = 'colorTextNeutralDefault',
  // @ts-expect-error size prop is taken from IconDualColorRoot
  size,
  // @ts-expect-error disabled prop is taken from IconDualColorRoot
  disabled,
  ...props
}: IconDualColorBottomProps) {
  const iconColor = disabled ? 'colorTextNeutralDisabled' : color

  return (
    <Icon
      data-testid="icon-dual-color-bottom"
      data-icon="bottom"
      data-size={size}
      color={iconColor}
      size={size}
      {...props}
    >
      {children}
    </Icon>
  )
}

IconDualColorBottom.displayName = 'IconDualColorBottom'
